import React from 'react';
import { Box } from 'theme-ui';

type Props = {
  onClick: () => void;
};

export const SettingsButton: React.FC<Props> = ({ onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: 'primary',
        width: 40,
        height: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        right: 4,
        bottom: 4,
        opacity: 0.4,
        color: 'primary',
        borderRadius: 6,
        '&:hover': {
          opacity: 1,
        },
        '&:active > svg': {
          fill: 'text',
        },
        '& > svg': {
          fill: 'primary',
        },
      }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="75%"
        height="75%"
        viewBox="0 0 48 48">
        <path d="M24 4c-1.577 0-3.097.2-4.549.537a1.5 1.5 0 0 0-1.15 1.299l-.319 2.902a2.997 2.997 0 0 1-4.189 2.418h-.002l-2.666-1.174a1.5 1.5 0 0 0-1.7.348 19.963 19.963 0 0 0-4.566 7.871 1.5 1.5 0 0 0 .55 1.645l2.364 1.734a2.999 2.999 0 0 1 0 4.84l-2.365 1.732a1.5 1.5 0 0 0-.549 1.645 19.957 19.957 0 0 0 4.567 7.873 1.5 1.5 0 0 0 1.699.346l2.666-1.174a2.999 2.999 0 0 1 4.191 2.42l.319 2.902a1.5 1.5 0 0 0 1.148 1.297C20.901 43.8 22.423 44 24 44s3.097-.2 4.549-.537a1.5 1.5 0 0 0 1.15-1.299l.319-2.902a2.999 2.999 0 0 1 4.19-2.42l2.667 1.174a1.5 1.5 0 0 0 1.7-.346 19.97 19.97 0 0 0 4.566-7.873 1.5 1.5 0 0 0-.55-1.645l-2.364-1.732A2.996 2.996 0 0 1 39 24c0-.958.454-1.853 1.227-2.42l2.365-1.732a1.5 1.5 0 0 0 .549-1.645 19.97 19.97 0 0 0-4.567-7.873 1.5 1.5 0 0 0-1.699-.346l-2.668 1.174a2.999 2.999 0 0 1-4.19-2.42L29.7 5.836a1.5 1.5 0 0 0-1.148-1.297A19.992 19.992 0 0 0 24 4zm0 3c.974 0 1.91.175 2.848.34l.187 1.724a6.003 6.003 0 0 0 8.38 4.84l1.587-.697a16.86 16.86 0 0 1 2.855 4.924l-1.406 1.031A6.003 6.003 0 0 0 36 24c0 1.91.912 3.708 2.451 4.838l1.406 1.031a16.86 16.86 0 0 1-2.855 4.924l-1.586-.697a6.003 6.003 0 0 0-8.38 4.84l-.188 1.724c-.938.165-1.874.34-2.848.34-.974 0-1.91-.175-2.848-.34l-.187-1.724a6.003 6.003 0 0 0-8.38-4.84l-1.587.697a16.848 16.848 0 0 1-2.855-4.924l1.406-1.031a6.003 6.003 0 0 0 0-9.678L8.143 18.13A16.852 16.852 0 0 1 11 13.205l1.584.697a6.002 6.002 0 0 0 8.38-4.838l.188-1.724C22.09 7.175 23.026 7 24 7zm0 9c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 3c2.78 0 5 2.22 5 5s-2.22 5-5 5-5-2.22-5-5 2.22-5 5-5z" />
      </svg>
    </Box>
  );
};
